import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <section className="home">
      <div className="home__hero">
        <h1 className="home__title">Cesta k úspěchu makléře</h1>
        <p className="home__lead">
          Drill podporuje makléře na jejich cestě od nastupu až po samostatnost —
          s přehledem o aktivitách, cílech a pokroku.
        </p>
        <div className="home__cta">
          <Link className="button button--primary" to="/login">Přihlásit se</Link>
        </div>
      </div>

      <div className="home__cards">
        <article className="card">
          <h3 className="card__title">Přehled aktivit</h3>
          <p className="card__text">Pravidelný zápis kontaktů a schůzek, který vám ukáže, jak blízko jste k cíli.</p>
        </article>

        <article className="card">
          <h3 className="card__title">Cíle a semafor</h3>
          <p className="card__text">Modrý, žutý a červený semafor podle vašeho týdenního plánu — vždy vidíte, kde jste.</p>
        </article>

        <article className="card">
          <h3 className="card__title">Kariérní cesta</h3>
          <p className="card__text">Vývojové úrovně a milníky, které vás doprovázejí od prvního měsíce až po samostatnost.</p>
        </article>
      </div>
    </section>
  );
}
